import { render, staticRenderFns } from "./ServiceNews.vue?vue&type=template&id=1b9eb5d6&scoped=true&"
import script from "./ServiceNews.vue?vue&type=script&lang=js&"
export * from "./ServiceNews.vue?vue&type=script&lang=js&"
import style0 from "./ServiceNews.vue?vue&type=style&index=0&id=1b9eb5d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9eb5d6",
  null
  
)

export default component.exports